enum GroupOrderingMode {
  Off = 'off',
  AskGroupOrderOptional = 'ask-group-order-optional-recipients',
  AskGroupOrderRequired = 'ask-group-order-required-recipients',
}

export { GroupOrderingMode };
